// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";

let jsonCodec = Jzon.object3(param => [
  param.place,
  param.beginTime,
  param.endTime
], param => ({
  TAG: "Ok",
  _0: {
    place: param[0],
    beginTime: param[1],
    endTime: param[2]
  }
}), Jzon.field("place", Document$LumiStore.Key.jsonCodec()), Jzon.field("beginTime", LumiDate.DateTime.jsonCodec), Jzon.field("endTime", Jzon.nullable(LumiDate.DateTime.jsonCodec)));

let Occupation = {
  jsonCodec: jsonCodec
};

function documentName(param) {
  
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "occupation",
  jsonCodec: jsonCodec,
  icon: "clock",
  readOnly: false
});

export {
  Occupation,
  Schema,
}
/* jsonCodec Not a pure module */
